import React from 'react';
import classnames from 'classnames';
import { map } from 'lodash';
import { Collapse } from '@mui/material';
import { TextField } from 'new/elements/TextField';
import {
  getCurrentSelectedOption,
  getNewSelectionValue,
  SelectInput,
  SelectOption,
} from '../elements/rselect/ReactSelectUtils';
import UnsortedSelect from '../elements/rselect/UnsortedSelect';
import { RemoveIconButton } from 'new/elements/Button/RemoveIconButton';

const styles = {
  description_input: {
    background: 'white',
  },
  delete_icon_tooltip: {
    marginLeft: 8,
    cursor: 'pointer',
  },
};

class AnnotationsRecipeGroup extends React.PureComponent {
  render() {
    const { isReadOnly, isExpanded } = this.props;

    return (
      <>
        <Collapse in={isExpanded}>{this._renderGroup()}</Collapse>
        {!isReadOnly && (
          <button className="add-recipe-button" onClick={this._handleAddClicked}>
            + Add New Annotation
          </button>
        )}
      </>
    );
  }

  _renderGroup = () => {
    const { data, outputSchema, isReadOnly, isInteractive, onRecipeClicked } = this.props;
    const attributeOptions = map(outputSchema, (attr) => ({
      label: attr.__txName,
      value: attr.__txName,
    }));

    if (isReadOnly) {
      return (
        <div className="schema-validations-editor">
          <ul className="filters-list">
            {map(data, (annotationData, index) => (
              <li
                key={index}
                className={classnames('filter-item is-blurred', {
                  'is-read-only': isReadOnly && !isInteractive,
                })}
                onClick={() => {
                  if (isReadOnly && isInteractive) {
                    onRecipeClicked(index);
                  }
                }}
              >
                <div className="left">
                  <h3>{annotationData.attr}</h3>
                  <span className="schema-validation-rule-description">
                    {annotationData.description}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return (
      <div className="transform-recipes">
        {map(data, (annotationData, index) => {
          const selectedAttribute = getCurrentSelectedOption(
            attributeOptions,
            annotationData.attr,
            null,
            null,
            true,
          );

          return (
            <div key={index} className="recipe-group-element annotation-recipe-element">
              <div className="left">
                <div className="recipe-input-row">
                  <label className="recipe-input-label">Attribute</label>
                  <div className="recipe-input-container">
                    <UnsortedSelect
                      isCreatable={true}
                      options={attributeOptions}
                      components={{
                        Input: SelectInput,
                        Option: SelectOption,
                      }}
                      backspaceRemovesValue={false}
                      variant="default"
                      isClearable={false}
                      isSearchable={true}
                      value={selectedAttribute}
                      onChange={(selectedOption) =>
                        this._handleAttributeChanged(selectedOption, index)
                      }
                    />
                  </div>
                </div>
                <div className="recipe-input-row">
                  <label className="recipe-input-label">Description</label>
                  <div className="recipe-input-container">
                    <TextField
                      fullWidth
                      variant="filled"
                      style={styles.description_input}
                      value={annotationData.description || ''}
                      onChange={(e) =>
                        /**
                         * @TODO
                         * improvement: add debounce
                         */
                        this._handleDescriptionChanged(e.target.value, index)
                      }
                    />
                  </div>
                </div>
              </div>
              <div style={styles.delete_icon_tooltip}>
                <RemoveIconButton
                  onClickRemove={(e) => {
                    e.stopPropagation();
                    this._handleDeleteClicked(index);
                  }}
                  tooltipText="Remove Rule"
                  className="delete-icon"
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  _handleAddClicked = () => {
    const { data, isExpanded, onExpand, onChangeRecipeGroup } = this.props;
    const newData = [
      ...data,
      {
        attr: '',
        description: '',
      },
    ];

    if (!isExpanded) {
      onExpand();
    }

    onChangeRecipeGroup(newData);
  };

  _handleDeleteClicked = (index) => {
    const { data, onChangeRecipeGroup } = this.props;
    const newData = [...data];
    newData.splice(index, 1);

    onChangeRecipeGroup(newData);
  };

  _handleAttributeChanged = (selectedOption, index) => {
    const { data, onChangeRecipeGroup } = this.props;
    const attr = getNewSelectionValue(selectedOption, true, '');
    const newData = [...data];
    newData[index] = {
      ...newData[index],
      attr,
    };

    onChangeRecipeGroup(newData);
  };

  _handleDescriptionChanged = (text, index) => {
    const { data, onChangeRecipeGroup } = this.props;
    const newData = [...data];
    newData[index] = {
      ...newData[index],
      description: text,
    };

    onChangeRecipeGroup(newData);
  };
}

export default AnnotationsRecipeGroup;
